import state from 'state';

export default function log(/*...*/) {
    if (!state.debug)
        return;
    // [].slice.call(arguments) leaks arguments and thus de-optimize in V8 and other engines
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/arguments
    var args = (arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments));
    args.unshift((new Date()).toISOString());
    window.console.log.apply(window.console, args);
}
